import { useEffect } from 'react';

var TAG_ID_KEY = 'tagid';
var TAG_LENGTH = 13;
// Get hash before its stripped
var hash = window.location.hash;
function useContentSquare() {
    useEffect(function () {
        // check for tag id in hash
        var tagParam = findTagId(hash);
        if (!validateTagId(tagParam))
            return function () { };
        addInitialTag(tagParam.value);
        var resetListeners = trackPageChanges();
        return resetListeners;
    }, []);
}
var findTagId = function (hash) {
    if (!hash || typeof hash !== 'string')
        return null;
    var parameters = hash.substring(1).split('&');
    var keyValues = parameters
        .filter(function (p) { return p.toLowerCase().startsWith(TAG_ID_KEY); })
        .map(function (k) {
        var _a = k.split('='), key = _a[0], value = _a[1];
        return { key: key, value: value };
    });
    return keyValues.length === 1 ? keyValues[0] : null;
};
var validateTagId = function (tagId) {
    if (!tagId || !tagId.value || tagId.value.length !== TAG_LENGTH)
        return false;
    return true;
};
var addInitialTag = function (tagId) {
    var mt = document.createElement("script");
    mt.type = "text/javascript";
    mt.async = true;
    mt.src = "//t.contentsquare.net/uxa/" + tagId + ".js";
    document.getElementsByTagName("head")[0].appendChild(mt);
};
var sendPageView = function (path) {
    window._uxa = window._uxa || [];
    window._uxa.push(['trackPageview', path]);
};
/**
* Send trackPageview event to content square
*/
var previousPath;
var trackPageChanges = function () {
    var pushStateHandler = window.history.pushState;
    var replaceStateHandler = window.history.replaceState;
    window.addEventListener('popstate', popstateHandler);
    window.history.pushState = function () {
        pushStateHandler.apply(this, arguments);
        sendPageView(window.document.location.pathname);
        previousPath = null;
    };
    window.history.replaceState = function () {
        replaceStateHandler.apply(this, arguments);
        sendPageView(window.document.location.pathname);
        previousPath = null;
    };
    return function () {
        window.removeEventListener('popstate', popstateHandler);
        window.history.pushState = pushStateHandler;
        window.history.replaceState = replaceStateHandler;
    };
};
var popstateHandler = function () {
    // Popstate will often be triggered on pageload, this hopefully removes duplicate calls
    if (window.document.location.pathname === previousPath)
        return;
    sendPageView(window.document.location.pathname);
    previousPath = window.document.location.pathname;
};

export { useContentSquare };
//# sourceMappingURL=index.es.js.map
